import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import i18n from './../i18n/i18n';
import {Button, ButtonToolbar, ModalFooter} from 'reactstrap';
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Komponenta pro akce u formulářů, akce mohou být buď součástí patičky dialogu nebo jako samostatný div kontejner.
 * Určení se provádí automaticky na základě kontektu.
 */
class FormActions extends AbstractReactComponent {

    static contextTypes = {
        isModal: React.PropTypes.bool
    };

    static PropTypes = {
        onClose: React.PropTypes.func,
        onSubmit: React.PropTypes.func,
        closeButton: React.PropTypes.bool,
        submitButton: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
        disabled: React.PropTypes.bool, // zakázání všech tlačítek
        submitDisabled: React.PropTypes.bool, // zakázání submit tlačítek
        okButton: React.PropTypes.bool,
        storeButton: React.PropTypes.bool,
        cancelButton: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
        createButton: React.PropTypes.bool,
        children: COMPONENT_CHILDREN
    };

    renderActions = () => {
        const {
            disabled,
            submitDisabled,
            onClose,
            onSubmit,
            closeButton,
            submitButton,
            okButton,
            storeButton,
            cancelButton,
            createButton,
        } = this.props;

        const result = [];

        const commonsSubmit = {
            disabled: disabled || submitDisabled
        };
        const commonsCancel = {
            disabled: disabled
        };

        if (submitButton) {
            if (submitButton === true) {
                result.push(<Button key={"submit"} {...commonsSubmit} color="primary" type="submit" onClick={onSubmit}>{i18n("global.form.action.ok")}</Button>)
            } else {
                result.push(<Button key={"submit"} {...commonsSubmit} color="primary" type="submit" onClick={onSubmit}>{submitButton}</Button>)
            }
        }

        okButton && result.push(<Button key={"ok"} {...commonsSubmit} color="primary" type="submit" onClick={onSubmit}>{i18n("global.form.action.ok")}</Button>);
        storeButton && result.push(<Button key={"store"} {...commonsSubmit} color="primary" type="submit" onClick={onSubmit}>{i18n("global.form.action.store")}</Button>);
        createButton && result.push(<Button key={"create"} {...commonsSubmit} color="primary" type="submit" onClick={onSubmit}>{i18n("global.form.action.create")}</Button>);

        closeButton && result.push(<Button key={"close"} {...commonsCancel} type="button" onClick={onClose}>{i18n("global.form.action.close")}</Button>);
        if (cancelButton) {
            if (cancelButton === true) {
                result.push(<Button key={"cancel"} {...commonsCancel} type="button" onClick={onClose}>{i18n("global.form.action.cancel")}</Button>)
            } else {
                result.push(<Button key={"cancel"} {...commonsCancel} type="button" onClick={onClose}>{cancelButton}</Button>)
            }
        }

        return result;
    };

    render() {
        const {
            children,
        } = this.props;

        let length = 0;
        if (children) {
            if (Array.isArray(children)) {
                length = children.length;
            } else {
                length = 1;
            }
        }

        const actions = this.renderActions();
        length += actions.length;

        const {isModal} = this.context;

        if (isModal) {
            return <ModalFooter className="form-actions-container">
                {children}
                {this.renderActions()}
            </ModalFooter>
        } else {
            return <div className="form-actions-container">
                {length > 1 ? <ButtonToolbar>
                    {children}
                    {actions}
                </ButtonToolbar>: <div>
                    {children}
                    {actions}
                </div>}
            </div>
        }
    }
}

export default FormActions
